(() => {
  const initStickyBuy = () => {
    const bar = document.querySelector('[data-pm-sticky-buy]');
    if (!bar) return;
    const triggerId = bar.querySelector('[data-pm-sticky-trigger]')?.dataset.pmStickyTrigger;
    const primary = triggerId ? document.getElementById(triggerId) : null;
    const stickyButton = bar.querySelector('[data-pm-sticky-trigger]');
    if (!primary || !stickyButton) return;

    const sync = () => {
      stickyButton.disabled = primary.disabled;
      stickyButton.textContent = primary.disabled ? 'SOLD OUT' : 'GET ACCESS';
    };
    sync();

    stickyButton.addEventListener('click', () => {
      sync();
      if (primary.disabled) {
        primary.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      primary.click();
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        if (window.matchMedia('(max-width: 749px)').matches) {
          bar.hidden = entry.isIntersecting;
        } else {
          bar.hidden = true;
        }
      }, { threshold: 0.1 });
      observer.observe(primary);
    } else if (window.matchMedia('(max-width: 749px)').matches) {
      bar.hidden = false;
    }

    document.addEventListener('change', () => setTimeout(sync, 80));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBuy, { once: true });
  } else {
    initStickyBuy();
  }
})();
